function registerAlertItems(): void {
  const currentDate = new Date();

  const alerts = document.querySelectorAll<HTMLElement>(`.alert-items > .alert`);

  alerts.forEach(alert => {
    const alertWrapper = alert.parentElement as HTMLElement | null;
    const alertDismissDays = parseInt(alert.dataset.alertDismissDurationDays || '0', 10);
    const alertId = alert.dataset.alertId;
    const alertDismissButtons = alert.querySelectorAll<HTMLElement>(`.alert-dismiss-button`);

    alertDismissButtons.forEach(dismissButton => {
      dismissButton.addEventListener('click', event => {
        if (alertDismissDays === 0) {
          // Use session cookie for alerts set to dismiss after 0 days.
          // Session storage is unique per tab. Session cookies are shared across tabs.
          setSessionCookie(`alert-dismiss-${alertId}`, 'session');
          
        } else {
          // Use local storage for alerts set to dismiss otherwise, containing date they will no longer be dismissed
          const dismissUntilDate = new Date(currentDate);
          dismissUntilDate.setDate(currentDate.getDate() + alertDismissDays);
          localStorage.setItem(`alert-dismiss-${alertId}`, dismissUntilDate.toISOString());
        }

        if (alertWrapper) {
          alertWrapper.classList.remove('show');
        }
        setSpacerHeights();
      });
    });

    // If alert is not dismissible or it is not dismissed in session cookie nor local storage, then show it
    const dismissible = alert.dataset.alertDismissible === 'true';
    const sessionCookieDismissValue = getCookie(`alert-dismiss-${alertId}`);
    const localStorageDismissUntilDate = new Date(localStorage.getItem(`alert-dismiss-${alertId}`) || null);


    if (!dismissible || (!sessionCookieDismissValue && localStorageDismissUntilDate < currentDate)) {
      alert.classList.add('show');
      if (alertWrapper) {
        alertWrapper.classList.add('show');
      }
    } else if (alertWrapper) {
      alertWrapper.classList.remove('show');
    }
  });

  setSpacerHeights();
}

// Set the height of alert spacers to the height of the alert to prevent content from being obstructed
function setSpacerHeights(): void {
  const alertSpacers = document.querySelectorAll<HTMLElement>(`.alert-spacer`);
  alertSpacers.forEach(x => {
    const nextElement = x.nextElementSibling as HTMLElement | null;
    if (nextElement) {
      x.style.height = nextElement.offsetHeight + 'px';
    }
  });

  setAlertOffset();
}

// Sets --alert-offset on :root to the header alert's current rendered height (0 when no alert
// is shown), so #main (see _page.scss) can shift down just enough to clear the alert without
// permanently pushing main down by the header's full height. Scoped to #header specifically
// because the footer has its own separate .alert-spacer that is unrelated to this offset.
function setAlertOffset(): void {
  const headerAlertSpacer = document.querySelector<HTMLElement>(`#header .alert-spacer`);
  const offset = headerAlertSpacer ? headerAlertSpacer.offsetHeight : 0;
  document.documentElement.style.setProperty('--alert-offset', `${offset}px`);
}

function setSessionCookie(name: string, value: string): void {
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; samesite=lax`;
}

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + encodeURIComponent(name) + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

document.addEventListener('DOMContentLoaded', () => {
  registerAlertItems();
});

// Recalculate spacer heights (and, in turn, --alert-offset) on resize, debounced so it
// doesn't run continuously while a user is actively resizing/dragging a window - e.g. a
// tablet rotating orientation, which otherwise leaves the offset stale until reload.
let resizeDebounceTimeout: ReturnType<typeof setTimeout> | undefined;

window.addEventListener('resize', () => {
  clearTimeout(resizeDebounceTimeout);
  resizeDebounceTimeout = setTimeout(() => {
    setSpacerHeights();
  }, 150);
});
